import { beezInCodeValidationService, getSubmissionModule } from "../../feathers";
import { getField, updateField } from "vuex-map-fields";

const state = {
    module: {}
};



const actions = {

    async validateBeezInCode({ commit }, code) {
        const data = await beezInCodeValidationService.create({
            code: code
        });

        commit("updateField", {
            path: "module",
            value: data
        });

        return data;
    },

    async getSubmissionModule(_, id){
        const data = await getSubmissionModule(id);
        return data;
    }
};

const mutations = {
    updateField
};
const getters = {
    getField
};
export default {
    namespaced: true,
    actions,
    getters,
    mutations,
    state
}